import React from "react";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";
import KeyBoardCheckPage from "./KeyboardCheckPage";
import HeadphoneCheckPage from "./HeadphonePage";
import MicrophoneCheckPage from "./MicrophonePage";
import TestIntroductionPage from "./TestIntroduction";
import SpeakingInstructionPage from "./SpeakingInstruction";
import FullSectionPage from "./FullSectionTable";
import SectionPage from "./SectionPage";
import PersonalIntroductionPage from "./PersonalIntroductionPage";
import ReadAloudPage from "./Speaking/ReadAloudPage";
import RepeatSentencePage from "./Speaking/RepeatSentencePage";
import DescribeImageMockPage from "./Speaking/DescribeImageMock";
import ReTellMockPage from "./Speaking/ReTellMock";
import ShortAnswersMockPage from "./Speaking/ShortAnswersMock";
import SummarizeMockPage from "./Writing/SummarizeMock";
import WriteEssayMockPage from "./Writing/WriteEssay";
import MultipleTypeSingleMockPage from "./Reading/MultipleTypeSingleMock";
import MultipleTypeDoubleMockPage from "./Reading/MultipleDoubleTypleMock";
import ReArrangeSentenceMockPage from "./Reading/ReArrangeMock";
import ReadingFillInTheBlanksMockPage from "./Reading/ReadingFillInTheBlanksMock";
import FillInTheBlanksReadingAndWritingMockPage from "./Reading/FillInTheBlanksReadingAndWritingMock";
import SummarizeSpokenTestMockPage from "./Listening/SummarizeSpokenTextMock";
import MCQSingleAnswerMockPage from "./Listening/MCQSingleAnswerMock";
import MCQMultipleAnswerMockPage from "./Listening/MCQMultipleAnswerMock";
import FillInTheBlanksMockPage from "./Listening/FillInTheBlanksMock";
import HighlightCorrectSummaryMockPage from "./Listening/HighlightCorrectSummaryMock";
import SelectMissingWordsMockPage from "./Listening/SelectMissingWordMock";
import HighlightIncorrectWordMockPage from "./Listening/HighlightIncorrectWordMock";
import WriteFromDictationMockPage from "./Listening/WriteFromDictationMock";
import Notification from "../QuestionPage/Notification";
import ConfirmDialog from "./PopUp";
import Loading from "./SpinnerLoading"; // Import the loading component
import Timer from "./Timer";
import ReadingSectionTable from "./ReadingSectionTable";

// function ConfirmDialog({ message, onConfirm, onCancel }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "white",
//         border: "1px solid #ccc",
//         padding: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <p>{message}</p>
//       <button onClick={onConfirm}>Yes</button>
//       <button onClick={onCancel}>No</button>
//     </div>
//   );
// }

// Page Html
export default function ReadingMockTestPage() {
  const [MockData, setMockData] = useState({
    data: [],
  });
  const [userInputs, setUserInputs] = useState({});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  useEffect(() => {
    const fetchMockData = async () => {
      try {
        const response = await fetch("/api/readingmockquestions/all", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setMockData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch MockTest data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching MockTest data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchMockData();
  }, []);

  console.log("Mock Data:", MockData.data.AnswershortQuestion);

  const handleInputChange = (questionType, questionIndex, answer) => {
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [questionType]: {
        ...prevInputs[questionType],
        [questionIndex]: answer,
      },
    }));
  };

  console.log("User Input", userInputs);

  const splitData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = async () => {
    const payload = { userInputs, MockData }; // Assuming userInputs and MockData are defined
    const payloadString = JSON.stringify(payload);
    const maxChunkSize = 50000; // Reduce the chunk size further (e.g., 50KB)
    const chunks = splitData(payloadString, maxChunkSize);

    console.log(`Total chunks: ${chunks.length}`);

    try {
      for (const [index, chunk] of chunks.entries()) {
        console.log(`Sending chunk ${index + 1} of ${chunks.length}`);
        const response = await fetch("/api/save-writingmocktestdata", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chunk, index, totalChunks: chunks.length }),
        });
        if (!response.ok) {
          console.error("Failed to submit data chunk. Status:", response.status);
          throw new Error(`Failed to submit data chunk. Status: ${response.status}`);
        }
      }
      console.log("Data submitted successfully");
      setMessage("Mock data saved successfully!");
      setNotificationType("success");
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      setMessage("Failed to save MockTest.");
      setNotificationType("error");
      setShowNotification(true); // Show error notification
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Empty dependency array to fetch data only once on mount
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 18;
  const handleNext = () => {
    setShowConfirmDialog(true);
    setNextPage((prevPage) => prevPage + 1);
  };

  const handleConfirm = () => {
    setShowConfirmDialog(false);
    setIsLoading(true); // Start loading

    // Set timeout to simulate loading delay
    setTimeout(() => {
      setIsLoading(false); // End loading
      setCurrentPage(nextPage); // Proceed to the next page
    }, 100);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false); // Hide the confirmation dialog
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const disableNext = currentPage === totalPages;
  const disablePrevious = currentPage === 1;

  const renderPage = () => {
  // SingleAnswer → Q1–2 (Pages 3–4)
    
  if (currentPage >= 3 && currentPage <= 4) {
    const questionIndex = currentPage - 3;
      const currentQuestion = MockData.data.SingleAnswer[questionIndex];
      return (
        <MultipleTypeSingleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 1} // Q1–2
        />
      );
    }

    // DoubleAnswer → Q3–4 (Pages 5–6)

  if (currentPage >= 5 && currentPage <= 6) {
      const questionIndex = currentPage - 5;
      const currentQuestion = MockData.data.DoubleAnswer[questionIndex];
      return (
        <MultipleTypeDoubleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 3} // Q3–4
          maxQuestion={16}
        />
      );
    }
    
    // ReorderParagraph → Q5–6 (Pages 7–8)

    if (currentPage >= 7 && currentPage <= 8) {
      const questionIndex = currentPage - 7;
      const currentQuestion = MockData.data.ReorderParagraph[questionIndex];
      return (
        <ReArrangeSentenceMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReorderParagraph", questionIndex, answer)
          }
          questionNumber={questionIndex + 5} // Q5–6
          maxQuestion={16}
        />
      );
    }
      // FillInTheBlank → Q7–11 (Pages 9–13)

      if (currentPage >= 9 && currentPage <= 13) {
        const questionIndex = currentPage - 9;
      const currentQuestion = MockData.data.FillInTheBlank[questionIndex];
      return (
        <ReadingFillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillInTheBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 7} // Q7–11
          maxQuestion={16}
        />
      );
    }
    
    // ReadingandWriting → Q12–16 (Pages 14–18)

    if (currentPage >= 14 && currentPage <= 18) {
      const questionIndex = currentPage - 14;
      const currentQuestion = MockData.data.ReadingandWriting[questionIndex];
      return (
        <FillInTheBlanksReadingAndWritingMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReadingandWriting", questionIndex, answer)
          }
          questionNumber={questionIndex + 12} // Q12–16
          maxQuestion={16}
        />
      );
    }


    switch (currentPage) {
  
      case 1:
        return <KeyBoardCheckPage />;
      case 2:
        return <ReadingSectionTable />;

      // case 26:
      //   return <WriteFromDictationMockPage />;

      default:
        return null;
    }
  };

  return (
    <div>
      {renderPage()}
      {isLoading && <Loading />}
      {showConfirmDialog && (
        <ConfirmDialog
          message="Proceed to the next question?"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      <div className="absolute top-16 font-bold p-2 pt-4 ml-[1255px] ">
        {" "}
        {currentPage >= 3 && (
          <Timer initialMinutes={24} initialSeconds={0} Text="Time Remaining" />
        )}
      </div>

      <MockNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        currentPage={currentPage} // Pass currentPage here
        totalPages={totalPages} // Pass totalPages here
        handleSubmit={handleSubmit} // Pass handleSubmit here
      />

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
